import { Component, OnInit } from '@angular/core';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [MatGridList, MatGridTile]
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
